import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomValidators } from '.';
import { Tr2ValidationBuilder } from 'app/utils/trip2-query-builder/tr2-validation-builder';


@Component({
  selector: 'app-custom-validators',
  templateUrl: './custom-validators.component.html',
  styleUrls: ['./custom-validators.component.scss']
})
export class CustomValidatorsComponent implements OnInit {
  from: FormGroup;

  rulesJson = {
    'url': {
      'rules': [
        'required',
        'minLength(4)',
        'CustomValidators.url'
      ]
    },
    'equals': {
      'rules': [
        'CustomValidators.equals(equals_compare,true)'
      ]
    },
    'inArray': {
      'rules': [
        'CustomValidators.inArray(1,2,3,text)'
      ]
    }
  };

  constructor(protected fb: FormBuilder) {
    this.from = this.fb.group({
      'url': [''],
      'name': [''],
      'equals_compare': [''],
      'equals': [''],
      'inArray': [''],
      'requiredIf': [''],
      'requiredIf_compare': [''],
      'queryBuilder': ['']
    });
  }


  ngOnInit() {
  }

  setRulesDemo(rules) {

    const _rules = [];

    rules.forEach(element => {
      const split = element.split('(');
      if (split.length > 1) {
        const params = element.substr(split[0].length + 1 , (element.length - 1) - (split[0].length + 1));
        if (split[0] === 'pattern' || split[0].search(CustomValidators._name) !== -1) {
          if (split[0] === 'pattern') {
            const regex = new RegExp(params);
            _rules.push(Validators[split[0]](regex));
          }

          if (split[0].search(CustomValidators._name) !== -1) {
            _rules.push(
              CustomValidators[split[0].split(CustomValidators._nameSplit)[1]](params)
            );
          }
        } else {
          _rules.push(Validators[split[0]](params));
        }
      } else {
        const custom = element.split(CustomValidators._nameSplit);
        if (custom.length === 2 ) {
          _rules.push(CustomValidators[custom[1]]);
        } else {
          _rules.push(Validators[element]);
        }
      }
    });

    return _rules;

  }

  applyValidation(formControlName: string, inJson = false) {
    this.from.get(formControlName).clearValidators();

    if (inJson) {
      const rules = this.setRulesDemo(this.rulesJson[formControlName].rules);
      this.from.get(formControlName).setValidators(rules);
    } else {
      this.from.get(formControlName).setValidators([CustomValidators.url]);
    }
    this.from.get(formControlName).updateValueAndValidity();
  }

  applyValidationEquals(inJson = false) {
    this.from.get('equals').clearValidators();

    if (inJson) {
      const rules = this.setRulesDemo(this.rulesJson.equals.rules);
      this.from.get('equals').setValidators(rules);
    } else {
      this.from.get('equals').setValidators([CustomValidators.equals({formControlName : 'equals_compare', sensitive: true})]);
    }
    this.from.get('equals').updateValueAndValidity();
  }

  applyValidationInArray(inJson = false) {
    this.from.get('inArray').clearValidators();

    if (inJson) {
      const rules = this.setRulesDemo(this.rulesJson.inArray.rules);
      this.from.get('inArray').setValidators(rules);
    } else {
      this.from.get('inArray').setValidators(
        [CustomValidators.inArray([1, 2, 3, 'text'])]
      );
    }
    this.from.get('inArray').updateValueAndValidity();
  }

  applyValidationRequiredIf(inJson = false) {

  }

  setQueryBuilder() {
    this.from.get('queryBuilder').clearValidators();

    this.from.get('queryBuilder').setValidators(
      Tr2ValidationBuilder
        .applyRules('required')
        .where('5', '===' , '1')
        .orWhere('5', '>', '4')
        .get().validations
    );


    this.from.get('queryBuilder').updateValueAndValidity();
  }

  _change() {
  }




}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/custom-validators/custom-validators.component.ts